var formatTime = {};

formatTime.transCommDate = function (date) {
  var ts = new Date(date).getTime();
  var D = new Date(ts);
  var y, M, d, h, m, s;
  y = D.getFullYear();
  M = D.getMonth() + 1;
  d = D.getDate();
  h = D.getHours();
  m = D.getMinutes();
  s = D.getSeconds(); // console.log(ts);
  // console.log(y + '-' + m + '-' + d);
  // let res = y + '-' + M + '-' + d + ' ' + h + ':' + m + ":" + s

  var res = y + '-' + M + '-' + d;
  return res;
}; // 格式化日期


formatTime.FormatDate = function () {
  var day = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var D = new Date();
  var y, M, d, h, m, s;
  y = D.getFullYear();
  M = D.getMonth() + 1;
  d = D.getDate() + day;
  h = D.getHours();
  m = D.getMinutes();
  s = D.getSeconds();
  return y + '-' + M + '-' + d + ' ' + h + ':' + m + ':' + s; // return y + '-' + M + '-' + d
};

export default formatTime;